import { useAuth } from "../contexts/authContext";
import { UserRoles } from "../types/core/auth.types";
import { BoardOwner } from "../types/app/boardOwner.types";

interface BoardPermission {
  isAdmin: boolean;
  isOwner: boolean;
  canEditBoard: boolean;
  canDeleteBoard: boolean;
  canManageOwners: boolean;
  canManageButtons: boolean;
  canCreateBoard: boolean;
}

export function useBoardPermission(
  ownerList?: BoardOwner[] | null,
  isOwnedByCurrentUserFlag?: boolean
): BoardPermission {
  const { user } = useAuth();
  const isAdmin = !!user && user.roles.indexOf(UserRoles.Admin) > -1;

  let isOwner = false;
  if (isOwnedByCurrentUserFlag !== undefined) {
    isOwner = isOwnedByCurrentUserFlag;
  } else if (ownerList && user) {
    isOwner = ownerList.some((o) => o.userId === user.id);
  }

  const canManage = isAdmin || isOwner;
  return {
    isAdmin,
    isOwner,
    canEditBoard: canManage,
    canDeleteBoard: canManage,
    canManageOwners: canManage,
    canManageButtons: canManage,
    canCreateBoard: isAdmin,
  };
}
